import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createPinia, type Pinia } from 'pinia';

/** Pinia Store */
const pinia: Pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export default pinia;

// Pinia Stores

import useGlobal from './global';
import useConfig from './config';
import useUser from './user';
import useLocale from './locale';
import useApiAdapter from './apiAdapter';
import usePreferences from './preferences';

export { useConfig, useUser, useGlobal, useLocale, useApiAdapter, usePreferences };
